import React from "react";

import Paper from "../../../../../componentsv2/Paper";
import { formatarMoedaBrl } from "../../../utils/descontoAgendamento";

function CardResumo({ titulo, valor, subtitulo }) {
  return (
    <Paper
      style={{
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <span style={{ color: "#7C8798", fontSize: "12px", fontWeight: 700 }}>
        {titulo}
      </span>
      <div style={{ color: "#1F3FA3", fontSize: "28px", fontWeight: 800, marginTop: "10px" }}>
        {valor}
      </div>
      <span style={{ color: "#7C8798", fontSize: "13px" }}>{subtitulo}</span>
    </Paper>
  );
}

export default function CardsResumoRelatorio({ resumo }) {
  const totalPedidos = resumo?.totalPedidos || 0;
  const totalSessoes = resumo?.totalSessoes || 0;
  const ticketMedio = resumo?.ticketMedio || 0;

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "16px",
        marginTop: "16px",
      }}
    >
      <CardResumo
        titulo="TOTAL DE PEDIDOS"
        valor={totalPedidos}
        subtitulo="pedidos realizados"
      />
      <CardResumo
        titulo="TOTAL DE SESSÕES"
        valor={totalSessoes}
        subtitulo="sessões realizadas"
      />
      <CardResumo
        titulo="TICKET MÉDIO"
        valor={formatarMoedaBrl(ticketMedio)}
        subtitulo="por pedido"
      />
    </div>
  );
}
